<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png"
             alt="菜单">
      </div>
      <div class="caidan-title">
        角色管理
      </div>
    </div>
    <!-- <div class="modul-search">
      <el-form :inline="true"
               :model="formInline"
               class="demo-form-inline">
        <el-form-item label="姓名">
          <el-input v-model="formInline.user"
                    clearable
                    placeholder="请输入员工名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="modul-btn">
        <el-button @click="addItem">新增</el-button>
      </div>
    </div> -->
    <!--  -->
    <div style="display: flex;font-size:18px;">
      <!--  -->
      <div style="width:300px;height: 100%;overflow:overlay">
        <el-row justify="space-between"
                style="align-items: center;
        height: 40px;
        margin-bottom: 10px;
        padding:0 8px;
        position: sticky;
        top: 0px;
        z-index: 999;
        background: #fff;"
                type="flex">
          <el-col :span="10"
                  class="Tree_tit_L">角色类型</el-col>
          <el-col :span="2"
                  class="Tree_tit_R">
            <el-button class="el-icon-plus"
                       type="text"
                       @click="addType()"></el-button>
          </el-col>
        </el-row>

        <el-tree :data="roledata"
                 :expand-on-click-node="false"
                 :props="defaultProps"
                 default-expand-all
                 highlight-current
                 node-key="id"
                 style="    height: calc( 100% - 50px );"
                 @node-click="handleNodeClick">
          <span slot-scope="{ node, data }"
                style="width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;padding:0 20px;font-size:12px;">
            <span>{{ node.label }}</span>
            <span>
              <el-button class="el-icon-edit"
                         type="text"
                         @click="() => edit(node,data)"></el-button>
              <el-button class="el-icon-minus"
                         type="text"
                         @click="() => remove(node, data)"></el-button>
              <el-button :style="{ 'visibility':node.level == 2 ? 'hidden':'visible'}"
                         class="el-icon-plus"
                         type="text"
                         @click="() => append(node,data)"></el-button>
            </span>
          </span>
        </el-tree>
      </div>
      <div style="width:500px;height: 100%;padding:0 0 0 20px">
        <div style="display: flex;justify-content: space-between;height:40px;margin-bottom:10px;background:#fff;line-height:40px;padding:  0 8px;">
          <div>角色名称：{{ name }}</div>
          <div>
            <el-button :loading="saveLoading"
                       type="primary"
                       @click="save()">保存</el-button>
          </div>
        </div>

        <el-tree ref="tree"
                 :data="data2"
                 :props="defaultProps2"
                 node-key="menuUuid"
                 show-checkbox
                 style="height: calc( 100% - 50px );overflow: overlay;padding: 0 8px;">
        </el-tree>
      </div>

      <!-- 添加编辑角色类型 -->
      <el-dialog :close-on-click-modal='false'
                 :modal-append-to-body="false"
                 :visible.sync="dialogVisible"
                 width="35%">
        <div class="modul-top1"
             slot="title">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png"
                 alt="菜单">
          </div>
          <div class="caidan-title">
            {{title}}
          </div>
        </div>
        <el-form ref="form"
                 :model="form"
                 :rules="rule"
                 label-width="120px">
          <el-form-item label="角色名"
                        prop="roleName">
            <el-input v-model="form.roleName"
                      autocomplete="off"
                      placeholder="请输入角色名"></el-input>
          </el-form-item>
          <el-form-item label="显示排序"
                        prop="sort">
            <el-input v-model.number="form.sort"
                      autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="dialogVisible = false"> 取 消</el-button>
          <el-button type="primary"
                     @click="submit('form')">确 定</el-button>
        </div>
      </el-dialog>

    </div>

  </div>
</template>
<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    //这里存放数据
    return {
      data2: [],//菜单数据
      defaultProps2: {
        children: 'childMenu',
        label: 'menuName'
      },
      name: '',
      roleUuid: null,
      saveLoading: false,
      loading: false,
      //角色树数据
      roledata: [],
      defaultProps: {
        children: 'childRole',
        label: 'roleName'
      },

      // 角色类型编辑
      title: '',
      dialogVisible: false,
      form: {
        roleName: "",
        sort: null,
      },
      rule: {
        roleName: [
          { required: true, message: '角色名不能为空', trigger: 'blur' }
        ],
      },
    }
  },
  computed: {
    path () {
      return this.$route.path
    },
  },
  watch: {
    path (one, two) {
      this.getTreeData()
      this.getData()
    }
  },
  methods: {
    //重置树选择
    resetChecked () {
      this.$refs['tree'].setCheckedKeys([])
    },
    //角色树数据
    async getTreeData () {
      this.loading = true;
      const res = await this.$api.sendPost("/role/list", {});
      if (res.errcode === 0) {
        this.roledata = res.data.voList;
        this.loading = false;
        // console.log('角色树数据', this.roledata);
      }
    },
    //获取菜单数据
    async getData () {
      this.loading = true;
      const res = await this.$api.sendPost("/menu/list", {});
      if (res.errcode === 0) {
        this.data2 = res.data.voList;
        this.resetChecked()
        this.loading = false;
        // console.log('角色树数据', this.data2);
      }
    },
    async handleNodeClick (node, e) {
      console.log('node', node);
      console.log('e', e);
      if (e.level == 1) {
        this.name = '';
        this.roleUuid = null;
      } else if (e.level == 2) {
        this.name = node.roleName
        this.roleUuid = node.roleUuid;
        const res = await this.$api.sendGet("/role/getMenuByRoleId", { roleUuid: this.roleUuid });
        if (res.errcode === 0) {
          this.resetChecked()
          if (res.data) {
            this.$refs['tree'].setCheckedKeys(res.data)
          }
        }
      }
    },
    remove (node, data) {
      // console.log(node)
      this.$confirm(node.level == 1 ? '删除此角色分类？' : '删除此角色?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$api.sendGet("/role/delete", { id: data.id });
        if (res.errcode === 0) {
          this.$message.success(res.errmsg);
          this.getTreeData()
        } else {
          this.$message.warning(res.errmsg);
        }
      })
    },
    edit (node, data) {
      this.title = node.level == 1 ? '编辑角色分类' : '编辑角色';
      this.form = JSON.parse(JSON.stringify(data));
      this.dialogVisible = true;
    },
    addType () {
      this.title = '新增角色类型'
      this.dialogVisible = true;
      this.form = {
        sort: this.roledata.length + 1
      };
    },
    append (node, data) {
      this.title = '新增角色'
      this.dialogVisible = true;
      this.form = {
        parentUuid: data.roleUuid,
      };
    },
    submit (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // console.log(this.form)
          const res = await this.$api.sendPost("/role/insertOrUpdateRole", this.form);
          if (res.errcode == 0) {
            this.getTreeData()
          } else {
            this.$message.warning(res.errmsg);
          }
          this.dialogVisible = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //给角色赋予菜单权限
    async save () {
      if (!this.roleUuid) {
        this.err({ message: '请先选择角色' })
      } else {
        let datas = [];
        let treeData = this.$refs['tree'].getCheckedNodes(false, true)
        treeData.map(e => {
          datas.push(e.menuUuid)
        })
        this.saveLoading = true;
        let data = {
          roleUuid: this.roleUuid,
          menuUuids: datas
        }
        // console.log(data)
        const res = await this.$api.sendPost("/role/insertRoleMenu", data);
        if (res.errcode === 0) {
          this.saveLoading = false;
          this.$message.success(res.errmsg);
        } else {
          this.$message.warning(res.errmsg);
        }
      }
    }

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created () {
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  async mounted () {
    this.getTreeData()
    this.getData()
  }
}
</script>
<style lang='scss' scoped>
.modul-search {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .modul-btn {
    margin-left: 50px;
  }
}
.Tree_tit {
  display: flex;
  flex-direction: row;
  align-items: center;
}
// /deep/.el-dialog {
//   height: 800px;
// }
</style>